/**
 * Проверка формата даты (ДД.ММ.ГГГГ)
 * @param {string} date - Дата для проверки
 * @returns {boolean} - Валидность даты
 */
export const isValidDateFormat = (date) => {
  // Регулярное выражение для проверки формата даты ДД.ММ.ГГГГ
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/;
  return dateRegex.test(date);
};

/**
 * Форматирование даты в формат ДД.ММ.ГГГГ
 * @param {Date} date - Объект даты
 * @returns {string} - Отформатированная дата
 */
export const formatDate = (date) => {
  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
};

/**
 * Преобразование строки даты в формате ДД.ММ.ГГГГ в объект Date
 * @param {string} dateString - Строка даты в формате ДД.ММ.ГГГГ
 * @returns {Date|null} - Объект даты или null, если формат неверный
 */
export const parseDateString = (dateString) => {
  if (!isValidDateFormat(dateString)) {
    return null;
  }

  const [day, month, year] = dateString.split(".").map(Number);
  return new Date(year, month - 1, day);
};
